<template>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped text-center"
        width="100%"
      >
        <thead class="bg-teal text-white">
          <tr>
            <th rowspan="2">Coligada</th>
            <th rowspan="2">Ano</th>
            <th colspan="2">Proposta</th>
            <th colspan="2">Reformulação</th>
            <th rowspan="2">Ações</th>
          </tr>
          <tr>
            <th>Início</th>
            <th>Término</th>
            <th>Início</th>
            <th>Término</th>
          </tr>
        </thead>
        <tbody v-if="orcamentos.length > 0">
          <tr v-for="orcamento in orcamentos" :key="orcamento.id">
            <td>{{ orcamento.codColigada }}</td>
            <td>{{ orcamento.ano }}</td>
            <td>{{ dateTimeSqlToDateBR(orcamento.dataInicialProposta) }}</td>
            <td>{{ dateTimeSqlToDateBR(orcamento.dataFinalProposta) }}</td>
            <td>
              {{ dateTimeSqlToDateBR(orcamento.dataInicialReformulacao) }}
            </td>
            <td>{{ dateTimeSqlToDateBR(orcamento.dataFinalReformulacao) }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-outline-warning btn-icon"
                title="Editar"
                @click="$emit('editOrcamento', orcamento.id)"
              >
                <i class="ph-pencil"></i>
              </button>
              <button
                v-if="orcamento.ativo == 0"
                type="button"
                class="btn btn-sm btn-outline-primary btn-icon ms-2"
                title="Definir este orçamento como ativo"
                @click="$emit('setActiveOrcamento', orcamento.id)"
              >
                <i class="ph-star"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">Nenhum orçamento cadastrado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { dateTimeSqlToDateBR } from '@/utils/date'

export default {
  name: 'ListOrcamentos',

  props: {
    orcamentos: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dateTimeSqlToDateBR,
    }
  },
}
</script>
